








































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {PropType} from 'vue'
import {$} from '@/facade'
import {OrbitRoundReward} from '@/model/resource/OrbitRoundReward'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import {OrbitApproveRewardStep} from '@/enums/OrbitApproveRewardStep'
import {NeoHelper} from '@/helpers/NeoHelper'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'
import {OrbitHelper} from '@/helpers/OrbitHelper'
import {DateHelper} from '@/helpers/DateHelper'

@Component({
  computed: {
    OrbitApproveRewardStep() {
      return OrbitApproveRewardStep
    },
  },
  components: {
    OrbitSuccessStep,
    OrbitLoadingTransactionStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
  },
})
export default class OrbitApproveRewardModal extends Vue {
  @Prop({type: Object as PropType<OrbitRoundReward | null>})
  orbitRoundReward!: OrbitRoundReward | null

  @Prop({type: Array as PropType<OrbitRoundReward[]>, default: () => []})
  orbitRoundRewards!: OrbitRoundReward[]

  currentStep: OrbitApproveRewardStep | null = null
  transactionHash: string | null = null

  get rewardsToApprove(): OrbitRoundReward[] {
    if (this.orbitRoundRewards && this.orbitRoundRewards.length > 0) {
      return this.orbitRoundRewards
    }
    if (this.orbitRoundReward) {
      return [this.orbitRoundReward]
    }
    return []
  }

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    await OrbitHelper.checkWalletPermissions().catch(() => {
      this.closeModal()
    })

    await this.approveReward()
  }

  async approveReward() {
    try {
      const rewards = this.rewardsToApprove
      if (!rewards || rewards.length === 0)
        throw new Error('Orbit round reward(s) required')

      const n3InvocationBuilder = getN3InvocationBuilder()

      const setClaimableArgs = rewards.map(reward => {
        const userScriptHash = NeoHelper.getScriptHashFromAddress(
          reward.address || ''
        )
        const projectScriptHash = reward.orbitProject?.contract?.hash || ''

        if (!userScriptHash || !projectScriptHash)
          throw new Error('Invalid script hashes')

        return {
          userScriptHash,
          projectScriptHash,
          amount: String(reward.amount),
        }
      })

      const invocation =
        setClaimableArgs.length === 1
          ? n3InvocationBuilder.setClaimableNEP17Invocation(setClaimableArgs[0])
          : n3InvocationBuilder.setClaimableNEP17MultipleInvocation(
              setClaimableArgs
            )

      this.currentStep = OrbitApproveRewardStep.WAITING_SIGNATURE
      this.transactionHash = await $.walletAdapter.invokeN3Wallet(invocation)

      if (!this.transactionHash) throw new Error('Undefined transaction')

      this.currentStep = OrbitApproveRewardStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        this.transactionHash
      )

      if (!isTransactionValid) throw new Error('Failed to verify transaction')

      await Promise.all(
        rewards.map(async reward => {
          reward.status = 'approved'
          reward.updatedAt = DateHelper.formatDateForBackend(Date.now()) as any

          await reward.persistOrbitRoundReward()
        })
      )

      this.currentStep = OrbitApproveRewardStep.APPROVED

      const message =
        rewards.length > 1
          ? `${rewards.length} rewards approved successfully`
          : $.translate('view.ListOrbitRewardsView.approvedSuccess')

      $.toast.success(message)
    } catch (error) {
      this.threatError(error)
    }
  }

  onClickCloseModal() {
    if (
      this.currentStep === OrbitApproveRewardStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitApproveRewardStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.closeModal()
  }

  closeModal() {
    this.currentStep = null
    this.transactionHash = null
    this.$emit('close')
  }

  @Watch('$store.state.walletAdapter.n3.address')
  async onN3AddressChange(address: string | null) {
    if (!address) {
      this.closeModal()
      return
    }

    await this.populateResources()
  }

  private threatError(error: any) {
    console.error(error)

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitApproveRewardStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitApproveRewardStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitApproveRewardStep.UNKNOWN_ERROR
  }
}
